import React from 'react';
import './Terms.css';

function Terms() {
  return (
    <div className="terms">
      <div className="terms-container">
        <h1>Terms and Conditions</h1>
        <h2>Last Updated: 15th March, 2026</h2>
        <p>
          These terms and conditions (<strong>"Terms"</strong>) govern the use of services made available on or through{' '}
          <a href='https://hynt.co.in/'>https://hynt.co.in/</a> and/or the HYNT SOLUTIONS PRIVATE LIMITED mobile app
          (collectively, the "Platform", and together with the services made available on or through the Platform, the{' '}
          <strong>"Services"</strong>). These Terms also include our privacy policy, available at{' '}
          <a href="https://hynt.co.in/privacy-policy">https://hynt.co.in/privacy-policy</a> (<strong>"Privacy Policy"</strong>),
          and any guidelines, additional, or supplemental terms, policies, and disclaimers made available or issued by us from
          time to time (<strong>"Supplemental Terms"</strong>). The Privacy Policy and the Supplemental Terms form an integral
          part of these Terms. In the event of a conflict between these Terms and the Supplemental Terms with respect to
          applicable Services, the Supplemental Terms will prevail.
          <br /><br />
          The Terms constitute a binding and enforceable legal contract between{' '}
          <strong>HYNT SOLUTIONS PRIVATE LIMITED</strong> (formerly known as HYNT Solutions LLP and earlier CircleSpace LLP),
          a company incorporated under the Companies Act, 2013, having its registered office at 1201 A Wing New Light CHS,
          TPS IV South Avenue Khar, Khar Colony, Mumbai, Mumbai- 400052, and Corporate Identification Number (CIN):
          U58200MH2026PTC465233 and its affiliates (<strong>"HYNT", "we", "us", or "our"</strong>), and you, a user of the
          Services, or any legal entity that books Professional Services (defined below) on behalf of end-users{' '}
          (<strong>"you" or "Customer"</strong>). By accessing or using the Services or Platform in any way, you represent and
          warrant that you have full legal capacity and authority to agree to and bind yourself to these Terms. If you represent
          any other person, you confirm and represent that you have the necessary power and authority to bind such person to
          these Terms.
          <br /><br />
          These Terms include intellectual property licenses. While you retain ownership of rights to the content you post or
          share, you provide us with a broad license to make your content available to HYNT and our community of users. In
          exchange, we provide you with a license to use the HYNT Platform for your use and enjoyment!
          <br /><br />
          By using the Services, you agree that you have read, understood, and are bound by, these Terms, as amended from time
          to time, and that you will comply with the requirements listed here. These Terms expressly supersede any prior written
          agreements with you (if any). If you do not agree to these Terms, or comply with the requirements listed here, please
          do not use the Services.
          <br /><br />

          <div className="section">
            <strong>1. SERVICES</strong>
            <ol type="a">
              <li>
                The Services include the provision of the Platform which functions as a digital marketplace, enabling you to
                conveniently discover, connect with, arrange, and schedule a wide range of home-based and allied services with
                independent third-party service providers of those services <strong>("Professionals")</strong>. As a part of the
                Services, HYNT facilitates the transfer of payments to Professionals for the services they render to you and
                collects payments on behalf of such Service Professionals.
              </li>
              <li>
                The services rendered by Professionals are referred to as <strong>"Professional Services"</strong>. The term{' '}
                <strong>"Services"</strong> does not include the Professional Services. HYNT does not provide the Professional
                Services and is not responsible for their provision. The Platform merely facilitates such engagement by
                providing tools for browsing, booking, communication, job applications and payment, thereby ensuring a seamless
                user experience. For clarity, the Professionals operate as independent contractors, and all Professional
                Services availed through the Platform are rendered solely by such Professionals, at their discretion and
                responsibility. HYNT and its affiliates do not employ Professionals, nor are the Professionals agents,
                contractors, or partners of HYNT or its affiliates. Professionals do not have the ability to bind or represent
                HYNT.
              </li>
              <li>
                Please note that the Platform is intended for use only within India. You agree that in the event you avail the
                Services or Professional Services from a legal jurisdiction other than the territory of India, you will be
                deemed to have accepted the HYNT terms and conditions applicable to that jurisdiction.
              </li>
              <li>
                A key part of the Services is HYNT's ability to send you notifications, text messages, electronic mails, or
                WhatsApp messages, including in connection with your bookings/appointments/purchases/job applications, your
                utilisation of the Services, or may also include updates, alerts, as a part of its promotional and marketing
                strategies. While you may opt out of receiving these text messages by contacting HYNT at{' '}
                <a href='mailto:grievances@hynt.co.in'>grievances@hynt.co.in</a> or by modifying your preferences through the
                in-Platform settings, you agree and acknowledge that certain service-related communications are integral to the
                effective delivery of the Services, and opting out of such communications this may impair or restrict HYNT's
                ability to provide the Services (or a part of the Services) to you.
              </li>
              <li>
                In certain instances, you may be required to furnish identification proof to avail the Services or the
                Professional Services, and hereby agree to do so. A failure to comply with this request may result in your
                inability to use the Services or Professional Services.
              </li>
              <li>
                HYNT Credits:
                <ol>
                  <li>
                    HYNT may, in its sole discretion, offer promotional codes that may be redeemed for credits, other features
                    or benefits related to the Services, and/or Professional Services, subject to any additional terms that may
                    apply on a promotional code <strong>("HYNT Credits")</strong>.
                  </li>
                  <li>
                    You agree that (i) you shall use HYNT Credits in a lawful manner, and only for the purposes specified by
                    such HYNT Credits, (ii) you shall not duplicate, sell, or transfer the HYNT Credits in any manner
                    (including by posting such codes on a public forum) unless you have HYNT's express prior consent to do so,
                    (iii) HYNT Credits may be disabled by HYNT at any time for any reason without any liability to you, (iv)
                    HYNT Credits are not valid for cash, and (v) HYNT Credits may expire prior to your use.
                  </li>
                  <li>
                    HYNT may, at its sole discretion, provide only certain users with HYNT Credits that may result in different
                    amounts charged for the same or similar services obtained by other users.
                  </li>
                  <li>
                    HYNT reserves the right to withhold or deduct credits or other features or benefits obtained through the
                    use of HYNT Credits, by you or any other user, if HYNT reasonably determines or believes that the use or
                    redemption of the HYNT Credits was in error, fraudulent, illegal, or in violation of the applicable HYNT
                    Credit terms or these Terms.
                  </li>
                </ol>
              </li>
            </ol>
          </div>

          <div className="section">
            <strong>2. ACCOUNT CREATION</strong>
            <ol>
              <li>
                To avail the Services, you will be required to create an account on the Platform <strong>("Account")</strong>.
                Access to certain functionalities of the Platform will require you to sign up and create an account on our
                Platform. For this purpose, you may be required to furnish certain details, including but not limited to your
                name, phone number and email address. To create an Account, you must be at least 18 years of age. Use of the
                Platform by anyone under 18 years of age is strictly prohibited. Additional account requirements, including
                verification of your account details, may apply depending on your use of the Platform.
              </li>
              <li>
                You warrant that all information furnished in connection with your Account is and shall remain accurate and
                true. You agree to promptly update your details on the Platform in the event of any change to or modification
                of this information.
              </li>
              <li>
                You are solely responsible for maintaining the security and confidentiality of your Account and agree to
                immediately notify us of any disclosure or unauthorised use of your Account or any other breach of security
                with respect to your Account.
              </li>
              <li>
                You are liable and accountable for all activities that take place through your Account, including activities
                performed by persons other than you. We shall not be liable for any unauthorised access to your Account.
              </li>
              <li>
                You agree to receive communications from us, which may include without limitation:
                <ol>
                  <li>requests and reminders for payments, invoices, and billing information</li>
                  <li>updates, alerts, and information regarding us, our affiliates and the Services</li>
                  <li>promotional offers, discounts, and information about products and services from us and our third party partners</li>
                  <li>surveys, feedback requests, and customer support-related communications</li>
                  <li>security, verification, and authentication messages, including notifications relating to account activity or potential misuse; and</li>
                  <li>any other matter in relation to the Services</li>
                </ol>
              </li>
            </ol>
          </div>

          <div className="section">
            <strong>3. USER CONTENT</strong>
            <ol>
              <li>
                Our Platform contains interactive features and services that allow users who have created an account with us
                to post, upload, publish, display, transmit, or submit photos, floor plans, reviews, feedback (as explained
                below), BOQs, profile pictures, saved boards, messages, comments, proposals, invoices, to-do lists, notes,
                schedules, change orders, time and expense tracking, selection boards and/or tear sheets or other content on
                or through the Platform (<strong>"User Content"</strong>). You may also post comments, suggestions, feedback,
                ideas, reviews of professionals, third-party service providers, third-party products, merchants, or
                third-party services, as well as input content into certain Automated Tools (<strong>"Input"</strong>).
              </li>
              <li>
                As part of the effective provision of the Services and quality control purposes, we may request reviews from
                you about Professionals and you agree and acknowledge that Professionals may provide reviews about you to us.
                You must not knowingly provide false, inaccurate, or misleading information in respect of the reviews.
                Reviews will be used by us for quality control purposes and to determine whether Customers and Service
                Professionals are appropriate users of the Platform. If we determine at our sole discretion that you are not
                an appropriate user, we reserve the right to cancel your registration and remove you from our Platform.
              </li>
              <li>
                You grant us a non-exclusive, worldwide, perpetual, irrevocable, transferable, sublicensable, and
                royalty-free licence to (i) use, publish, display, store, host, transfer, process, communicate, distribute,
                make available, modify, adapt, translate, and create derivative works of, the User Content, for the
                functioning of, and in connection with, the Services and (ii) use User Content for the limited purposes of
                advertising and promoting the Services, or furnishing evidence before a court or authority of competent
                jurisdiction under applicable laws.
              </li>
              <li>
                In connection with these Terms and the licences granted under this clause, you hereby waive any claims
                arising out of any moral rights or other similar rights relating to the User Content.
              </li>
              <li>
                You agree and acknowledge that HYNT may, without notice to you, remove, or otherwise restrict access to
                User Content that, in its sole discretion, violates these Terms.
              </li>
            </ol>
          </div>

          <div className="section">
            <strong>4. CONSENT TO USE DATA</strong>
            <ol>
              <li>
                You agree that we may, in accordance with our Privacy Policy, collect and use your personal data. The
                Privacy Policy is available at{' '}
                <a href="https://hynt.co.in/privacy-policy" target="_blank" rel="noreferrer">
                  https://hynt.co.in/privacy-policy
                </a>{' '}
                and it explains the categories of personal data that we collect or otherwise process about you and the manner
                in which we process such data.
              </li>
              <li>
                In addition to any consent you may provide pursuant to the Privacy Policy, you hereby consent to us sharing
                your information with our affiliates or other third party service providers. We may use information and data
                pertaining to your use of the Services for provision of the Services, analytics, trend identification, and
                purposes of statistics to further enhance the effectiveness and efficiency of our Services, and provision of
                beneficial schemes, new offers, and for experience enhancement.
              </li>
              <li>
                Subject to applicable laws, we may be directed by law enforcement agencies or the government and related
                bodies to disclose data in relation to you in connection with criminal or civil proceedings. You understand
                and agree that in such instances we shall have the right to share such data with relevant agencies or bodies.
              </li>
              <li>
                Subject to these Terms, including the restrictions below, we grant you a limited non-exclusive licence to
                use and access User Content in connection with your use of the Platform. Except as expressly agreed to
                otherwise by us (such as your eligibility for creation of a professional profile or you are entering into
                Professional Services, seller, vendor, advertiser, trade, or any other agreement with us), your use of the
                Platform must be limited to personal non-commercial use. We may terminate this licence at any time for any
                reason. Except for the rights and licence granted in these terms, we reserve all other rights and grant no
                other rights or licences, implied or otherwise.
              </li>
            </ol>
          </div>

          <div className="section">
            <strong>5. PRICING, FEES, AND PAYMENT TERMS</strong>
            <ol type="a">
              <li>
                HYNT reserves the right to charge you for the different Services you may avail and/or for any other
                facilities you may opt for, from time to time, on or via the Platform.
              </li>
              <li>
                Charges and Fees in respect of Professional Services:
                <ol type="i">
                  <li>
                    In respect of Professional Services that you seek to avail through the Platform, you shall be required to
                    pay Professionals the amount indicated at the time of booking an appointment as well as amounts towards
                    (a) any additional Professional Services you may avail, (b) out of pocket expenses incurred by the
                    Professional, and (c) expenses arising out of the purchase of goods required or utilised for the
                    performance of the Professional Service (<strong>"Charges"</strong>). In addition to the Charges payable
                    to Service Professionals, HYNT reserves the right to charge you a convenience fee for facilitating the
                    booking and transferring payments to the Professional (this fee is referred to as <strong>"Fees"</strong>).
                    You acknowledge that the final bill you receive may include additional charges, including without
                    limitation, a safety fee, warranty fee, insurance fee, or Service Professional welfare fee.
                  </li>
                  <li>
                    HYNT shall notify you of the applicable Charges, Fees, and payment methods at the time of booking of an
                    appointment. Generally, you may make payments for Professional Services through credit cards, debit cards,
                    net banking, wallets, UPI or cash upon completion of the Professional Service. We have the right to modify
                    and otherwise restrict the modes of payment available to you. You acknowledge that certain payment methods
                    such as cash upon completion may not always be available to you as a payment method. For the avoidance of
                    doubt, in the event you pay through the method of 'cash upon completion', you acknowledge that you will be
                    required to pay both Charges and Fees to the Professional.
                  </li>
                  <li>
                    HYNT has the right to store certain information about your payment methods. You must promptly update your
                    payment method and related information (for example, a change in your billing address or credit card
                    expiration date) to maintain its accuracy and completeness. We may update the information and continue
                    billing your payment method (e.g., credit card) even after it has expired or been updated, to fulfill
                    transactions you authorise.
                  </li>
                  <li>
                    The Charges and Fees may be payable at the time of making a booking of an appointment, or upon the
                    completion of the Professional Service, as specified by HYNT.
                  </li>
                  <li>
                    For the avoidance of doubt, please note that the Charges are payable to Professionals, and HYNT acts as a
                    limited collection agent on behalf of such Professionals to collect and transfer amounts due to them.
                  </li>
                  <li>
                    <strong>Taxes:</strong> All Charges and Fees payable are exclusive of applicable taxes, duties, levies,
                    or cess, which shall be charged in addition thereto, as per applicable law. The applicable taxes and their
                    bifurcation shall be clearly reflected on the payment gateway page at the time of payment.
                  </li>
                  <li>
                    HYNT reserves the right to reasonably amend the Charges and Fees at any time at its sole discretion. A
                    change in Fees shall not impact any bookings that have been confirmed before the publication of the
                    revised Fees on the Platform.
                  </li>
                  <li>
                    Charges and Fees that you pay are final and non-refundable, unless otherwise determined by HYNT or
                    required by the applicable laws. Under certain laws, you may be entitled to a refund or other remedies
                    for a failure in the provision of the Services.
                  </li>
                  <li>
                    If we are unable to collect amounts owed by you, we may limit your use of the HYNT Platform. You agree
                    that we may collect those amounts owed using any legal manner without prejudice to any other right or
                    remedy we may be entitled to under these Terms or by law. In the event that HYNT brings any action or
                    suit to collect any amounts owed, HYNT will be entitled to recover our costs, including reasonable
                    attorneys' fees incurred in such collection. Any amounts past due will be subject to a late fee of the
                    lesser of 1.5% per month or the maximum amount permitted by law.
                  </li>
                  <li>
                    You acknowledge and agree that Charges and Fees applicable in certain geographical areas may increase
                    substantially during times of high demand. HYNT will use reasonable efforts to inform you of the Charges
                    and Fees that may apply. However, by using the Professional Services, you will be responsible for the
                    Charges and Fees incurred under your Account regardless of your awareness of such Charges or Fees.
                  </li>
                </ol>
              </li>
              <li>
                Payment Processors: We may use a third-party payment processor (<strong>"Payment Processor"</strong>) to
                bill you through your selected mode of payment. The processing of payments will be subject to the terms and
                policies of such Payment Processor in addition to these Terms. We shall not be liable for any error, delay,
                deficiency, or failure on the part of the Payment Processor. In the event of any unsuccessful payment, the
                money debited shall be credited in accordance with the terms of the Payment Processor.
              </li>
              <li>
                Cancellation: You may elect to cancel your request for services from a Professional at any time prior to
                such Professional's arrival, in which case you may be charged a cancellation fee. HYNT reserves the right to
                charge you, or otherwise deduct applicable taxes in respect of such cancellation fee.
              </li>
              <li>
                Subscriptions: HYNT may from time to time offer subscription packages (howsoever named) for monetary
                consideration. The packages shall provide Customers with additional benefits, which may include the ability
                to avail Professional Services. You agree that subscription packages (howsoever named) shall be subject to
                additional terms and conditions. You acknowledge that such subscription packages will be subject to
                additional terms and conditions that will be deemed to be an integral part of these Terms.
              </li>
              <li>
                Additional Terms for subscriptions: Each subscription package shall be subject to specific terms and
                conditions, pricing, and inclusions, which shall be notified to you at the time of purchase. Such terms
                shall be deemed incorporated into, and form an integral part of, these Terms. Subscriptions may be billed on
                a recurring basis (e.g., monthly, quarterly, annually) as per the package selected by you. Unless you cancel
                your subscription in accordance with the cancellation process notified by us, your subscription will
                automatically renew at the then-prevailing rate. You may cancel your subscription at any time; however,
                unless expressly stated otherwise in the applicable package terms, subscription fees once paid are
                non-refundable, whether in whole or in part. HYNT reserves the right to modify, discontinue, or replace any
                subscription package, its features, or its pricing, at its sole discretion, subject to applicable law. Any
                such changes shall be notified to you in advance, and your continued use of the subscription thereafter
                shall constitute acceptance of such changes. Subscription packages are personal to you and may not be
                assigned, transferred, or shared with any third party, unless expressly permitted by HYNT in writing. HYNT
                reserves the right to suspend or terminate your subscription, without liability, in the event of (a) breach
                of these Terms, (b) non-payment of subscription fees, or (c) misuse of subscription benefits.
              </li>
              <li>
                HYNT does not designate any portion of your payment as a tip or gratuity to the Professional. Any
                representation by HYNT to the effect that tipping is "voluntary", "not required", and/or "included" in the
                payments you make for Professional Services is not intended to suggest that HYNT provides any additional
                payments to Professionals. You understand and agree that while you are free to provide additional payment as
                a gratuity to any Professional who provides you with Professional Services, you are under no obligation to
                do so. Gratuities are voluntary.
              </li>
            </ol>
          </div>

          <section>
            <strong>6. CUSTOMER CONDUCT</strong>
            <ol type="a">
              <li>
                HYNT prohibits discrimination against Professionals, including on the basis of race, religion, caste,
                national origin, disability, sexual orientation, sex, marital status, gender identity, age, or any other
                characteristic that may be protected under applicable law. Such discrimination includes but is not limited
                to any refusal to accept Professional Services based on any of these characteristics.
              </li>
              <li>
                We request that you treat all Professionals with courtesy and respect. Professionals shall be entitled to
                refuse to perform Professional Services if you behave towards them in a manner which is discourteous,
                disrespectful, abusive, or otherwise inappropriate. We reserve the right to withhold access to the Services
                and otherwise limit your access to Professional Services at our absolute discretion if you behave towards
                any Professional in a manner which is discourteous, disrespectful, or abusive, or which we otherwise deem
                to be inappropriate or unlawful.
              </li>
            </ol>
          </section>

          <section>
            <strong>7. THIRD PARTY SERVICES</strong>
            <ol type="a">
              <li>
                The Platform enables access to third-party content, products, and services, such as access to services from
                professionals, and it offers interactions with third parties that we do not control. We assume no
                responsibility for, nor do we endorse or verify the content, offerings or conduct of third parties
                (including but not limited to the products or services offered by third parties or the descriptions of the
                products or services offered by third parties).
              </li>
              <li>
                HYNT does not conduct background checks or otherwise vet the professionals listed on the Platform.
                Participation or availability on the Platform does not amount to endorsement or verification by us, and HYNT
                does not endorse or recommend the products, services, or other offerings by any professional, merchants, or
                other third party featured on the Platform, including leads provided through the Platform. HYNT provides a
                directory of professionals for informational purposes only. You are solely responsible for conducting your
                own due diligence and vetting, including verifying licences, certifications, and references, before engaging
                with any professional.
              </li>
              <li>
                The Platform may include services, content, documents, and information owned by, licensed to, or otherwise
                made available by, a third party (<strong>"Third Party Services"</strong>) and contain links to Third Party
                Services. You understand and acknowledge that Third Party Services are the sole responsibility of the third
                party that created or provided it and that use of such Third Party Services is solely at your own risk.
              </li>
              <li>
                We make no representations and exclude all warranties and liabilities arising out of or pertaining to such
                Third Party Services, including their accuracy or completeness. Should you avail a Third Party Service, you
                shall be governed and bound by the terms and conditions and privacy policy of the third parties providing
                the Third Party Services. Further, all intellectual property rights in and to Third Party Services are the
                property of the respective third parties.
              </li>
            </ol>
          </section>

          <section>
            <strong>8. YOUR RESPONSIBILITIES</strong>
            <ol type="a">
              <li>
                You represent and warrant that all information that you provide in relation to the Services and Professional
                Services is complete, true, and correct on the date of agreeing to these Terms and shall continue to be
                complete, true, and correct while you avail the Services and/or the Professional Services. Should any
                information that you provide change during the existence of these Terms, you undertake to immediately bring
                such change to our notice. We do not accept any responsibility or liability for any loss or damage that you
                may suffer or incur if any information, documentation, material, or data, provided to avail the Services is
                incorrect, incomplete, inaccurate, or misleading or if you fail to disclose any material fact.
              </li>
              <li>
                You shall extend all cooperation to us in our defence of any proceedings that may be initiated against us
                due to a breach of your obligations or covenants under these Terms.
              </li>
              <li>
                In respect of the User Content, you represent and warrant that:
                <ol type="i">
                  <li>you own all intellectual property rights (or have obtained all necessary permissions) to provide User Content and to grant the licences under these Terms;</li>
                  <li>you are solely responsible for all activities that occur on or through your account on the Platform and all User Content;</li>
                  <li>the User Content does not and shall not violate any of your obligations or responsibilities under other agreements;</li>
                  <li>the User Content does not and shall not violate, infringe, or misappropriate any intellectual property right or other proprietary right including the right of publicity or privacy of any person or entity;</li>
                  <li>the User Content does not and shall not contain any viruses, corrupted data, or other harmful, disruptive, or destructive files or content;</li>
                  <li>the User Content does not and shall not violate any third party rights; and</li>
                  <li>
                    the User Content (A) does not belong to any other person to which you do not have any right, (B) does
                    not threaten the unity, integrity, defence, security or sovereignty of India, friendly relations with
                    foreign states, public order, cause incitement to the commission of any cognisable offence, prevents
                    investigation of any offence, or is insulting another nation, (C) is not defamatory, grossly harmful,
                    blasphemous, paedophilic, invasive of another's privacy, discriminatory based on gender, ethnically
                    objectionable, disparaging, relating to, or encouraging money laundering or gambling, libellous,
                    hateful, racist, violent, obscene, pornographic, unlawful, harmful to children, or (D) otherwise
                    offensive, objectionable, or restricts, or inhibits, any other person from using or enjoying the
                    Services.
                  </li>
                </ol>
              </li>
              <li>
                You shall not use the Services in any manner except as expressly permitted in these Terms. Without limiting
                the generality of the preceding sentence, you shall not:
                <ol type="i">
                  <li>infringe any proprietary rights, including but not limited to copyrights, patents, trademarks, or trade secrets of any party;</li>
                  <li>except as may be provided hereunder, copy, display, distribute, modify, publish, reproduce, store, transmit, post, translate, create any derivative works from or license the Services;</li>
                  <li>use the Services to transmit any data, or send or upload any material that contains viruses, Trojan horses, worms, timebombs, keystroke loggers, spyware, adware, or any other harmful programmes, or similar computer code, designed to adversely affect the operation of any computer software or hardware;</li>
                  <li>use any robot, spider, other automated device, or manual process to monitor or copy the Services or any portion thereof;</li>
                  <li>engage in the systematic retrieval of content from the Services to create or compile, directly or indirectly, a collection, compilation, database, or directory;</li>
                  <li>use the Services in (A) any unlawful manner, (B) for fraudulent or malicious activities or (C) in any manner inconsistent with these Terms;</li>
                  <li>decompile, reverse engineer, or disassemble the Services;</li>
                  <li>link to, mirror, or frame, any portion of all or any of the Services; or</li>
                  <li>violate applicable laws in any manner.</li>
                </ol>
              </li>
              <li>You warrant that you shall not engage in any activity that interferes with or disrupts the Services.</li>
              <li>
                You shall not attempt to gain unauthorised access to any portion or feature of the Services, any other
                systems or networks connected to the Services, to any of our servers, or through the Platform by hacking,
                password mining, or any other illegitimate means.
              </li>
              <li>
                You shall not directly or indirectly, in any capacity, solicit, attempt to influence, engage, approach, or
                accept or encourage the solicitations or approach of, a Service Professional from whom you have availed
                Professional Services, to either terminate or otherwise cease their registration on or engagement with the
                Platform, or avail services the same as or similar to the Professional Services independently, without
                booking the Professional Services through your Account. You agree that this limitation is reasonable and
                fair and is necessary for the protection of the privacy and security of Professionals and that this will not
                preclude you from obtaining services the same as or similar to the Professional Services through the
                Platform or other means. You further agree that any potential harm to Professionals from the
                non-enforcement of this clause far outweighs any potential harm to you.
              </li>
            </ol>
          </section>

          <section>
            <strong>9. OUR INTELLECTUAL PROPERTY</strong>
            <ol type="a">
              <li>
                All rights, titles, and interest in, and to the Services, including all intellectual property rights arising
                out of the Services, are owned by or otherwise licensed to us. Subject to compliance with these Terms, we
                grant you a non-exclusive, non-transferable, non-sub licensable, revocable, and limited licence to use the
                Services in accordance with these Terms and our written instructions issued from time to time. Any rights
                not expressly granted herein are reserved by HYNT or HYNT's licensors.
              </li>
              <li>
                As a HYNT user you are responsible for the content you upload and provide to the Platform. The Terms do not
                allow posting, sharing, or sending any content that violates or infringes someone else's copyrights,
                trademarks, or other intellectual property rights. As set forth in the Terms, users who have uploaded
                content to the Platform have represented and warranted that they have all of the rights necessary to do so,
                and grant us a licence to the content to permit HYNT to use it on the Platform.
              </li>
              <li>
                If you infringe the copyrights or other intellectual property rights of others, content may be removed or
                suspended in whole or part, consistent with this Policy and/or applicable law.
              </li>
              <li>
                We may request you to submit suggestions and other feedback, including bug reports, relating to the Services
                from time to time (<strong>"Feedback"</strong>). We may freely use, copy, disclose, publish, display,
                distribute, and exploit the Feedback we receive from you without any payment of royalty, acknowledgement,
                prior consent, or any other form of restriction arising out of your intellectual property rights.
              </li>
              <li>
                Except as expressly stated in these Terms, nothing in these Terms should be construed as conferring any
                right in, or licence to, our or any third party's intellectual property rights.
              </li>
              <li>
                If you believe your intellectual property has been infringed by the materials posted on the Platform, you
                (or your agent) may send us a notice requesting that the material be removed or access to it blocked. The
                notice must include the following information: (a) a physical or electronic signature of a person authorised
                to act on behalf of the owner of an exclusive right that is allegedly infringed; (b) identification of the
                intellectual property right claimed to have been infringed (or if multiple intellectual property located on
                the Platform are covered by a single notification, a representative list of registrations, as an example);
                (c) identification of the material that is claimed to be infringing or the subject of infringing activity,
                and information reasonably sufficient to allow HYNT to locate the material on the Platform; (d) information
                reasonably sufficient to permit HYNT to contact the complaining party, such as the name, address, telephone
                number, and email address (if available) of the complaining party; (e) a statement that the complaining
                party has a good faith belief that use of the material in the manner complained of is not authorised by the
                intellectual property rights owner, its agent, or the law; and (f) a statement that the information in the
                notification is accurate and, under penalty of perjury, that the complaining party is authorised to act on
                behalf of the owner of an exclusive right that is allegedly infringed. We will not respond to complaints
                that do not meet these requirements. We may also ask for additional information related to your intellectual
                property rights.
              </li>
              <li>
                Note that HYNT does not mediate intellectual property disputes between third parties and rights owners.
                Should a third party contest an allegation you submitted against them, we may forward the claim to the
                third party, with your email address and contact information, with the intent that the third party and you
                may resolve any dispute over ownership rights and/or infringement. We will only reinstate or re-list content
                taken down under intellectual property violations upon receipt of a retraction (sent to{' '}
                <a href="mailto:grievances@hynt.co.in">grievances@hynt.co.in</a>) from the rights owner.
              </li>
              <li>
                It is our policy, in appropriate circumstances and our discretion, to disable and/or terminate accounts of
                users who repeatedly infringe or are charged repeatedly with infringing the intellectual property rights of
                others.
              </li>
            </ol>
          </section>

          <section>
            <strong>10. TERM AND TERMINATION</strong>
            <ol type="a">
              <li>These Terms shall remain in effect unless terminated in accordance with the terms hereunder.</li>
              <li>
                We may restrict, deactivate, or terminate your access to, or use of, the Services, or any portion thereof,
                (i) immediately and at any point at our sole discretion, (A) if you violate or breach any of the
                obligations, responsibilities, or covenants under these Terms, (B) when you cease to become a user of our
                Services, (C) you do not, or are likely not to qualify under applicable law, or the standards and policies
                of HYNT or its affiliates, to access and use the Services, or (D) violate or breach the Community
                Guidelines, (iii) immediately for any legitimate business, legal, or regulatory reason.
              </li>
              <li>
                You may terminate these Terms, at any time, for any reason by sending a notice to HYNT at{' '}
                <a href="mailto:grievances@hynt.co.in">grievances@hynt.co.in</a>
              </li>
              <li>
                Upon termination of these Terms:
                <ol type="i">
                  <li>the Account will expire;</li>
                  <li>the Services will "time-out"; and</li>
                  <li>these Terms shall terminate, except for those clauses that are expressly, or by implication, intended to survive termination or expiry.</li>
                </ol>
              </li>
            </ol>
          </section>

          <section>
            <strong>11. DISCLAIMERS AND WARRANTIES</strong>
            <ol type="a">
              <li>
                The Services are provided on an "as is" basis without warranty of any kind, express, implied, statutory or
                otherwise, including without limitation the implied warranties of title, non-infringement,
                merchantability, or fitness for a particular purpose. Without limiting the foregoing, we make no warranty
                that the Services will meet your requirements or expectations.
              </li>
              <li>
                No advice or information, whether oral or written, obtained by you from us shall create any warranty that
                is not expressly stated in the Terms.
              </li>
              <li>
                While HYNT strives to provide accurate information about Professional Services and Charges, pricing errors
                may occur from time to time. The HYNT entities make no promises with respect to, and expressly disclaim all
                liability, to the maximum extent permitted by law, for: (i) content posted by any third party on the
                Platform, including, but not limited to, your content, (ii) the product descriptions or products, (iii)
                third-party sites and any third-party product or service listed on or accessible to you through the site,
                (iv) the quality or conduct of any third-party you encounter in connection with your use of the site, and
                (v) use of the tools (including visual tools and automated tools), including their accuracy, completeness,
                reliability, and results.
              </li>
              <li>
                You agree and acknowledge that we are merely a Platform that connects you with Professionals, and we shall
                not be liable in any manner for any obligations that have not been explicitly stated in these Terms. We are
                not liable or responsible for fulfilment of any bookings, for the performance of the Professional Services
                by any Professional, or for any acts or omissions of the Professionals during their provision of the
                Professional Services including any damage they may cause to property. By booking Professional Services
                through the Platform, you are entering into a contract with the relevant Service Provider for the provision
                of those services, and we accept no responsibility or liability, nor do we make any warranty,
                representation, or guarantee in respect of the Professional's performance under that contract.
              </li>
              <li>
                You agree and acknowledge that soliciting or receiving services from any Professional independently is
                solely at your own risk, and in such an event, you waive any rights that you may have under these Terms.
              </li>
              <li>
                We do not guarantee or warrant and we make no representation whatsoever regarding the reliability,
                quality, or suitability of the Professionals.
              </li>
              <li>
                You hereby accept full responsibility for any consequences that may arise from your use of the Services and
                Professional Services, and expressly agree and acknowledge that we shall have absolutely no liability in
                this regard.
              </li>
              <li>
                HYNT has appointed a Grievance Redressal Officer who will maintain a complaints management framework and
                will manage this framework on behalf of Professionals in a reasonable manner and in accordance with the
                non-excludable requirements of relevant applicable laws.
              </li>
              <li>
                To the fullest extent permissible by law, we, our affiliates, and our related parties, each disclaim all
                liability for any loss or damage arising out of, or due to:
                <ol type="i">
                  <li>your use of, inability to use, or availability or unavailability of the Services or the Professional Services;</li>
                  <li>the occurrence or existence of any defect, interruption, or delays, in the operation or transmission of information to, from, or through the Services, communications failure, theft, destruction, or unauthorised access to our records, programmes, services, servers, or other infrastructure relating to the Services;</li>
                  <li>the failure of the Services to remain operational for any period of time; and</li>
                  <li>the loss of any User Content and any other data in connection with your use of the Services.</li>
                </ol>
              </li>
              <li>
                In no event shall HYNT SOLUTIONS PRIVATE LIMITED, its directors, officers, employees, and representatives,
                or its contractors, agents, licensors, partners, or suppliers, be liable to you for any direct, special,
                indirect, incidental, consequential, punitive, reliance, or exemplary damages (including without
                limitation, lost business opportunities, lost revenues, or loss of anticipated profits or any other
                pecuniary or non-pecuniary loss or damage of any nature whatsoever, including but not limited to any abuse
                or breach of data), even if HYNT or an authorised representative had been advised of the possibility of
                such damages, arising out of, or relating to (A) these Terms, (B) the Services or the Professional
                Services, (C) your use or inability to use the Services or the Professional Services, or (D) any other
                interactions with another user of the Services.
              </li>
              <li>
                Nothing in these Terms will exclude or limit any warranty implied by law that it would be unlawful to
                exclude or limit.
              </li>
            </ol>
          </section>

          <section>
            <strong>12. INDEMNITY</strong>
            <p>
              You shall fully indemnify, defend at our option, and hold us, our parent companies, subsidiaries, affiliates,
              and our officers, employees, directors, agents, and representatives, harmless from and against any claim,
              demand, lawsuits, judicial proceeding, losses, liabilities, damages, and costs (including, without limitation,
              all damages, liabilities, settlements, and attorneys' fees), due to or arising out of (a) your breach of any
              part of this Agreement, including but not limited to the Policy and Cookie Policy; (b) any allegation that any
              materials you submit to us or transmit to the Platform, including Your Content, infringe or otherwise violate
              the copyright, patent, trademark, trade secret, or other intellectual property or other rights of any third
              party; (c) your access to the Services or Professional Services, use of the Services or Professional Services,
              violation of these Terms, or any violation of these Terms by any third party who may use your Account; and (d)
              your negligent or willful misconduct.
            </p>
          </section>

          <br />

          <section>
            <strong>13. JURISDICTION, GOVERNING LAWS, AND DISPUTE RESOLUTION</strong>
            <ol type="a">
              <li>
                These Terms shall be governed by and construed and enforced in accordance with the laws of India. Subject
                to other provisions in this clause, courts in Mumbai shall have exclusive jurisdiction over all issues
                arising out of these Terms or the use of the Services.
              </li>
              <li>
                Any controversies, conflicts, disputes, or differences, arising out of these Terms shall be resolved by
                arbitration in accordance with the Arbitration and Conciliation Act, 1996 for the time being in force,
                which is deemed to be incorporated by reference in this clause. The arbitrator shall be mutually appointed
                by the parties. In the event of failure to mutually agree within 30 days, either party may approach the
                appropriate court under Section 11 of the Arbitration and Conciliation Act, 1996. The language of the
                arbitration shall be English. The venue and seat of Arbitration shall be Mumbai. The parties to the
                arbitration shall keep the arbitration confidential, and not disclose to any person, other than on a need
                to know basis, or to legal advisors, unless required to do so by law. The decision of the arbitrator shall
                be final and binding on all the parties thereto. Each party to the arbitration shall bear its own costs
                with respect to any dispute.
              </li>
            </ol>
          </section>

          <section>
            <strong>14. GRIEVANCE REDRESSAL</strong>
            <ol type="a">
              <li>
                You may contact our designated Grievance Redressal Officer with any complaints or queries relating to the
                Services or these Terms through registered post or through email, details of which are provided below:
                <br />
                Name: Harsh Shah
                <br />
                Designation: COO
                <br />
                Email Address:{' '}
                <a href="mailto:grievances@hynt.co.in">grievances@hynt.co.in</a>
              </li>
              <li>We shall ensure that your complaint is resolved as expeditiously as possible.</li>
            </ol>
          </section>

          <section>
            <strong>15. MISCELLANEOUS PROVISIONS</strong>
            <ol type="a">
              <li>
                <strong>Changes to Terms:</strong> The Terms are subject to revisions at any time, as determined by us, and
                all changes are effective immediately upon being posted on the Platform. It is your responsibility to review
                these Terms periodically for any updates or changes. You will be deemed to have accepted the changes made to
                these Terms if you continue to use the Platform once it has been posted.
              </li>
              <li>
                <strong>Modification to the Services:</strong> We reserve the right at any time to add, modify, or
                discontinue, temporarily or permanently, the Services (or any part thereof), with or without cause. We
                shall not be liable for any such addition, modification, suspension, or discontinuation of the Services.
              </li>
              <li>
                <strong>Severability:</strong> If any provision of these Terms is determined by any court or other
                competent authority to be unlawful or unenforceable, the other provisions of these Terms will continue to
                be in effect. If any unlawful or unenforceable provision would be lawful or enforceable if a part of it
                were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect
                (unless that would contradict the clear intention of the clause, in which case the entirety of the relevant
                provision will be deemed to be deleted).
              </li>
              <li>
                <strong>Assignment:</strong> You shall not license, sell, transfer, or assign your rights, obligations, or
                covenants under these Terms, or your Account in any manner without our prior written consent. We may grant
                or withhold this consent at our sole discretion, subject to any conditions we deem appropriate. We may
                assign our rights to any of our affiliates, subsidiaries, or parent companies, any successor in interest
                including pursuant to any merger, acquisition, restructuring, or corporate conversion, of any business
                associated with the Services, or any third party without any prior notice to you.
              </li>
              <li>
                <strong>Notices:</strong> All notices, requests, demands, and determinations for us under these Terms
                (other than routine operational communications) shall be sent to{' '}
                <a href="mailto:grievances@hynt.co.in">grievances@hynt.co.in</a>.
              </li>
              <li>
                <strong>Third Party Rights:</strong> No third party shall have any rights to enforce any terms contained
                herein.
              </li>
              <li>
                <strong>Force Majeure:</strong> We shall have no liability to you if we are prevented from or delayed in
                performing our obligations, or from carrying on our business, by acts, events, omissions, or accidents
                beyond our reasonable control, including without limitation, strikes, failure of a utility service or
                telecommunications network, act of God, war, riot, civil commotion, malicious damage, or compliance with
                any law or governmental order, rule, regulation, or direction.
              </li>
            </ol>
          </section>

        </p>
      </div>
    </div>
  );
}

export default Terms;